import config from '@/core/config/config';
import { AffirmFooterLogo, PrenuvoFooterLogo } from './FooterLogos';

const Bottom = () => {
  return (
    <div className="flex min-h-20 flex-col-reverse items-start justify-between gap-10 gap-y-10 py-16 text-white lg:flex-row lg:items-center lg:px-0">
      <div className="flex flex-col flex-wrap items-start gap-10 md:flex-row md:items-center">
        <div className="md:min-h-[98px]">
          <a
            href={`${config.BASE_URL}/`}
            aria-label="click this link to go back to the home page"
            aria-current="page"
            className="transition ease-in-out hover:opacity-70"
          >
            <PrenuvoFooterLogo />
          </a>
        </div>
        <p className="align-text-top text-xs text-neutral-500">
          Copyright © {new Date().getFullYear()} - All rights reserved by Prenuvo, Inc.
        </p>
      </div>
      <div className="mr-auto flex flex-col flex-wrap gap-10 md:flex-row">
        <p>
          <a
            id="Terms-of-service"
            aria-label="click this link to view our Terms of service"
            href={`${config.BASE_URL}/terms`}
            className="text-xs font-semibold text-geyser-500 transition ease-in-out hover:text-green-100"
          >
            Terms of service
          </a>
        </p>
        <p>
          <a
            id="Privacy-policy"
            aria-label="click this link to go to privacy"
            href={`${config.BASE_URL}/privacy`}
            className="text-xs font-semibold text-geyser-500 transition ease-in-out hover:text-green-100"
          >
            Privacy policy
          </a>
        </p>
      </div>
      <div className="flex flex-col-reverse gap-3 md:flex-row-reverse md:flex-wrap md:items-end lg:flex-row lg:items-baseline">
        <p className="text-xs text-neutral-500">Financing partners where available</p>
        <div>
          <AffirmFooterLogo />
        </div>
      </div>
    </div>
  );
};

export default Bottom;
